import Image from "next/image";
import React from "react";

const Logo = ({
  setSeed,
  seed,
  className,
  today,
  width = 150,
  height = 50,
}: {
  setSeed?: (seed: bigint) => void;
  seed?: bigint;
  today?: bigint;
  className?: string;
  width?: number;
  height?: number;
}) => {
  return (
    <div
      className={
        className ? className : "absolute top-1 left-3 z-10 select-none"
      }
    >
      <Image priority src="/logo4.svg" width={150} height={50} alt="logo" />
    </div>
  );
};

export default Logo;
